import { CollisionGroupManager } from 'excalibur';

export const trashCollisionGroup = CollisionGroupManager.create('trash');
